import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTIVE_SEGMENTS_SUCCESS:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_SEGMENTS:
          return Object.assign({}, state, { isLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_SEGMENTS:
          return Object.assign({}, state, { isLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
